export const ADD_AI_CARD = 'ADD_AI_CARD';
export const COPY_AI_CARD = 'COPY_AI_CARD';
export const UPDATE_AI_CARD = 'UPDATE_AI_CARD';
export const AI_CARD_CLICK = 'AI_CARD_CLICK';
export const TIMELINE_MEMBER_HIGHLIGHTED = 'TIMELINE_MEMBER_HIGHLIGHTED';
export const TIMELINE_DATE_CHANGED = 'TIMELINE_DATE_CHANGED';
export const ADD_CARD = 'ADD_CARD';
export const DELETE_CARD = 'DELETE_CARD';
export const UPDATE_CARD = 'UPDATE_CARD';
export const UPDATE_BASED_ON_AI_POPUP = 'UPDATE_BASED_ON_AI_POPUP';
export const UPDATE_AI_TYPE = 'UPDATE_AI_TYPE';
export const WS_BOARD_UPDATE_S3DATA = 'WS_BOARD_UPDATE_S3DATA';
export const BOARD_FREETEXT_ADD = 'BOARD_FREETEXT_ADD';
export const BOARD_FREETEXT_UPDATE = 'BOARD_FREETEXT_UPDATE';
export const BOARD_UPDATE_ITEM_IN_COLUMN = 'BOARD_UPDATE_ITEM_IN_COLUMN';
export const BOARD_DELETE_ITEM_IN_COLUMN = 'BOARD_DELETE_ITEM_IN_COLUMN';
export const BOARD_UPDATE_RELATIONSHIP_COUNTS = 'BOARD_UPDATE_RELATIONSHIP_COUNTS';
export const BOARD_FREETEXT_UPDATE_IMG = 'BOARD_FREETEXT_UPDATE_IMG';

interface AddAICard {
    type: typeof ADD_AI_CARD,
    columnId: string,
    payload: any
}

interface CopyAiCard {
    type: typeof COPY_AI_CARD,
    columnId: string,
    payload: any
}

interface UpdateAICard {
    type: typeof UPDATE_AI_CARD,
    columnId: string,
    id: string,
    payload: any
}

interface AiCardClick {
    type: typeof AI_CARD_CLICK,
    payload: any
    columnId: string,
}

interface TimelineMemberHighlighted {
    type: typeof TIMELINE_MEMBER_HIGHLIGHTED,
    memberId: string
}

interface TimelineDataChanged
{
    type: typeof TIMELINE_DATE_CHANGED,
    value: any
}

interface AddCard
{
    type: typeof ADD_CARD,
    columnId: string,
    cardType: number,
    items: any
}

interface DeleteCard
{
    type: typeof DELETE_CARD,
    columnId: string,
    id: string,
    cardType?: number
}

interface UpdateCard
{
    type: typeof UPDATE_CARD,
    columnId: string,
    id: string,
    cardType: number,
    item: any
}

interface BoardUpdateS3Data {
    type: typeof WS_BOARD_UPDATE_S3DATA,
    payload: any
}

interface BoardFreeTextAdd {
    type: typeof BOARD_FREETEXT_ADD,
    payload: any
}

interface BoardFreeTextUpdate {
    type: typeof BOARD_FREETEXT_UPDATE,
    payload: any,
    id: number
}
interface BoardUpdateItemInColumn {
    type: typeof BOARD_UPDATE_ITEM_IN_COLUMN,
    payload: any
}
interface BoardDelteItemInColumn {
    type: typeof BOARD_DELETE_ITEM_IN_COLUMN,
    payload: any
}

interface UpdateBasedOnAIPopup
{
    type: typeof UPDATE_BASED_ON_AI_POPUP,
    payload: any
}

interface UpdateAiType
{
    type: typeof UPDATE_AI_TYPE,
    id: string,
    aiType: number,
}

interface UpdateBoardRelationshipCounts {
    type: typeof BOARD_UPDATE_RELATIONSHIP_COUNTS,
    payload: {
        requestedIds: number[],
        counts: Array<{actionItemId: number, relationshipsCount: number}>
    }
}

interface BoardFreeTextUpdateImg {
    type: typeof BOARD_FREETEXT_UPDATE_IMG,
    payload: any,
    id: number
}

export type CardActionTypes = AddAICard
                            | CopyAiCard
                            | UpdateAICard 
                            | AiCardClick
                            | TimelineMemberHighlighted
                            | TimelineDataChanged
                            | AddCard
                            | DeleteCard
                            | UpdateCard
                            | UpdateBasedOnAIPopup
                            | UpdateAiType
                            | BoardUpdateS3Data
                            | BoardFreeTextAdd
                            | BoardFreeTextUpdate
                            | BoardUpdateItemInColumn
                            | BoardDelteItemInColumn
                            | UpdateBoardRelationshipCounts
                            | BoardFreeTextUpdateImg;